// @flow
import socketIoClient from 'socket.io-client';
import environment from '../../environment';

export type SocketConnection = {
  close: () => void;
  on: (action: string, (item: any) => void) => void;
  off: (action: string) => void;
};

const SOCKET_PATH = '/v2/rt';

export function socketConnect(namespace: string, message?: { [key: string]: any }): SocketConnection {
  const socketUrl = `${environment.ioBaseUrl}/${namespace}`;
  const socket = socketIoClient(socketUrl, { path: SOCKET_PATH });
  if (message) {
    socket.emit('connectionInitialServer', message);
  }
  return socket;
}



// WEBPACK FOOTER //
// ./src/utils/socket/index.js